export const OTPService = ({ BeURL, email, Setmessage, setConfirm, setIsOpen, purpose }) => {
    fetch(`${BeURL}/send-otp`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, purpose })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                Setmessage(data.message)
                setConfirm(true)
                if (purpose !== "forgot-password") {
                    setIsOpen(true);
                }
            }
            else {
                Setmessage(data.message)
                setConfirm(false)
                setIsOpen(false)
            }
        })
        .catch(err => {
            console.log('Error while requesting OTP:', err)
            alert('Trouble in connecting to the Server! Please try again later.')
        })

}
